<!--经销商组织架构建议值列表-->
<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form :inline="true"
             :model="dataForm"
             @keyup.enter.native="queryStandardValue()"
             @submit.native.prevent>
      <el-row>
        <el-col :span="7">
          <!--年份-->
          <el-form-item :label="$t('res.cri.year')">
            <el-select v-model="dataForm.carryoverId">
              <el-option
                v-for="item in carryoverRecordList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item>
            <el-button size="mini" type="primary" @click="queryStandardValue">{{ $t('query') }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="button-group">
      <!--展开-->
      <el-button class="el-button-columnBtn" size="mini"
                 @click="unFoldAll">{{ $t('res.classroom.unFold') }}</el-button>
      <!--收起所有-->
      <el-button class="el-button-columnBtn" size="mini"
                 @click="foldAll">{{ $t('res.classroom.fold') }}</el-button>
    </div>
    <el-table
      v-if="isShowTable"
      v-loading="loading"
      :data="tableData"
      ref="tableTreeRef"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      :row-class-name="tableRowClassName"
      :default-expand-all="isExpand"
      :tree-props="{children: 'children'}">
      <!--部门/岗位名称-->
      <el-table-column
        prop="name"
        :label="$t('res.departmentValue.departmentJobName')">
      </el-table-column>
      <!--岗位代码-->
      <el-table-column
        prop="code"
        :label="$t('res.department.jobCode')">
        <template slot-scope="scope">
          <span v-if="scope.row.nodeType === '20'">{{scope.row.code}}</span>
        </template>
      </el-table-column>
      <!--标准人数-->
      <el-table-column
        prop="number"
        width="200"
        :label="$t('res.departmentValue.standardNum')">
        <template slot-scope="scope">
          <div style="line-height: 34px;">
            <el-input style="width: 80px!important;display: inline-block;" :readonly="!isStandardNumEdit" v-if="scope.row.nodeType === '20'" maxlength="10" v-model.trim="scope.row.standardValue"></el-input>
            <el-button v-if="scope.row.nodeType === '20' && isStandardNumEdit" @click="saveStandardValue(scope.row)" class="el-icon-success ipl"></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      isExpand: true,
      carryoverRecordList: [],
      dataForm: {
        orgId: '',
        dealerSize: '',
        carryoverId: ''
      },
      tableData: [],
      isShowTable: true,
      loading: false,
      // 是否禁用标准人数编辑
      isStandardNumEdit: true
    }
  },
  // 进来页面初始化获取数据
  activated () {
    this.$nextTick(() => {
      if (this.$route.query.orgId !== undefined && this.$route.query.dealerSize !== undefined) {
        this.dataForm.orgId = this.$route.query.orgId
        this.dataForm.dealerSize = this.$route.query.dealerSize
        // 查询归档年份下拉选
        this.getCarryoverRecord(this.dataForm.orgId)
        this.$nextTick(() => {
          this.getInfo()
        })
      }
    })
  },
  watch: {
    tableData: function () {
      this.$nextTick(() => {
        this.expandAll()
      })
    }
  },
  methods: {
    // 查询归档年份
    getCarryoverRecord (orgId) {
      this.$request.get('/talent/carryoverRecord/getList', { orgId: orgId}).then((data) => {
        this.carryoverRecordList = []
        let _this = this
        data.forEach(function (item) {
          let param = { value: item.id, label: item.year }
          _this.carryoverRecordList.push(JSON.parse(JSON.stringify(param)))
          if (item.isDefaultShow === '1') {
            _this.dataForm.carryoverId = item.id
          }
        })
      })
    },
    // 根据nodeType判断，给岗位和部门区分颜色
    tableRowClassName ({ row }) {
      if (row.nodeType === '10') {
        return 'success-row'
      }
      return ''
    },
    // 查询
    queryStandardValue () {
      this.getInfo()
    },
    // 查询建议值
    getInfo () {
      this.loading = true
      let _this = this
      _this.$request.post(`/talent/positionstandardvalue/queryDealerOrgInfo`, _this.dataForm).then((data) => {
        _this.tableData = data
        if (!_this.dataForm.carryoverId || _this.dataForm.carryoverId === 0) {
          _this.isStandardNumEdit = true
        } else {
          // 历史年份
          _this.isStandardNumEdit = false
        }
        _this.loading = false
      }).catch(() => {
        _this.loading = false
      })
    },
    // 校验是否是正整数
    isPositiveInteger (s) {
      let re = /^\+?[1-9][0-9]*$/
      return re.test(s)
    },
    // 保存建议值修改
    saveStandardValue (row) {
      // 如果建议值为空提示
      if (!row.standardValue && row.standardValue !== 0) {
        this.$message.warning(this.$t('talentpool.standardValueIsNotEmpty'))
        return false
      }
      if (!this.isPositiveInteger(row.standardValue)) {
        this.$message.warning(this.$t('talentpool.standardValueMustNumber'))
        return false
      }
      let param = {
        'id': row.positionStandardValueId,
        'dealerId': this.dataForm.orgId,
        'templateId': row.templateId,
        'positionId': row.commonId,
        'standardValue': row.standardValue
      }
      this.$request.post(`/talent/positionstandardvalue/update`, param).then((data) => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            // this.getInfo()
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleProgress (event, file, fileList) {
      console.log(file)
    },
    /**
     * 触发所有展开图标的click事件
     */
    expandAll () {
      // 获取点击的箭头元素
      let els = document.getElementsByClassName('el-table__expand-icon')
      for (let i = 0; i < els.length; i++) {
        els[i].click()
      }
    },
    /**
     * 展开所有下级
     */
    unFoldAll () {
      this.isShowTable = false
      this.$nextTick(function () {
        this.isShowTable = true
        let _this = this
        window.setTimeout(function () {
          _this.expandAll()
        }, 300)
      })
    },
    /**
     * 收起所有下级
     */
    foldAll () {
      this.isShowTable = false
      this.$nextTick(function () {
        this.isShowTable = true
      })
    }
  }
  // ,
  // mounted: {
  //
  // }
}
</script>
<style>
  /*.cell .el-table__placeholder {*/
    /*position: relative;*/
    /*margin-left: 20px;*/
  /*}*/
  .input-align-right input {
    text-align: right;
  }
  .el-table .success-row {
    background: #cbdcf0;
  }
</style>
